import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckTableRan } from '@api/consistencyCheck';

import { extractQueryParams } from '@utils/common';

import { IConsistencyCheckRan } from '@interfaces/cmModule/consistencyCheck';
import { IConsistencyCheckRanTableDTO } from '@interfaces/cmModule/dto/consistencyCheckDTO';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_RAN_TABLE } from '@constants/queryKeys';

interface IUseQueryConsistencyCheckRanTable {
	consistencyRanTableData: IConsistencyCheckRan[];
	countOfRecords: number;
	isLoadingConsistencyRanTable: boolean;
}

const useQueryConsistencyCheckRanTable = (params: IConsistencyCheckRanTableDTO): IUseQueryConsistencyCheckRanTable => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [CONSISTENCY_RAN_TABLE, params],
		queryFn: extractQueryParams(getConsistencyCheckTableRan),
		enabled: [!!params.page, !!params.pageSize],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		consistencyRanTableData: data?.items || [],
		countOfRecords: data?.count || 0,
		isLoadingConsistencyRanTable: isInitialLoading,
	};
};

export default useQueryConsistencyCheckRanTable;
